import React, { Fragment, useContext, useState } from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Dropdown, DropdownButton } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { faEye, faPaperPlane, faUser } from "@fortawesome/free-regular-svg-icons";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { faCircleXmark, faWarning, faCoins, faEllipsisV, faCashRegister, faBan, faTrash, faPencil } from "@fortawesome/free-solid-svg-icons";
import { postMethod } from "../../requests";
import { BasicContext } from "../../App";
import PurchaseDetailsModal from "../modals/PurchaseDetailsModal";
import UserClassesToPassModal from "../modals/UserClassesToPassModal";
import RegisterPaymentModal from "../modals/RegisterPaymentModal";
import ConfirmModal from "../modals/ConfirmModal";
import DeleteUserPassModal from "../modals/DeleteUserPassModal";

const UserPass = (props) => {
    const { t } = useTranslation();
    const { changeView, setAlerts, checkServerData } = useContext(BasicContext);
    const { pass, onlyDisplay, adminView, reload, reloadData, showUserName } = props;
    const [showPurchaseDetailsModal, setShowPurchaseDetailsModal] = useState(false);
    const [showUserClassesToPassModal, setShowUserClassesToPassModal] = useState(false);
    const [showRegisterPaymentModal, setShowRegisterPaymentModal] = useState(false);
    const [showCancelPaymentModal, setShowCancelPaymentModal] = useState(false);
    const [showDeletePassModal, setShowDeletePassModal] = useState(false);

    const sendReminder = async (up) => {
        setAlerts([{ variant: "info", message: t("info.sendingEmail") }]);
        const res = await postMethod("/send-user-pass-reminder", { up: up });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "emailSent" }]);
        }
    };

    const cancelPaymentForPass = async (up) => {
        const res = await postMethod("/cancel-payment-for-pass", { up: up });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "cancelled" }]);
            reload();
        }
    };

    const trStyle = pass.up_status_code === "DELETED" ? "pass-deleted" : !pass.up_paid ? "pass-not-paid" : pass.up_paid < pass.up_price ? "pass-not-fully-paid" : "";

    return (
        <Fragment>
            <tr className={trStyle}>
                <td className={`align-middle bold pb-0 pb-lg-2 lh-1 pt-2 border-bottom-0 ext-border-top ${onlyDisplay ? "ext-border-left" : ""}`}>{pass.pass_name}</td>
                <td
                    className={`align-middle pb-0 pb-lg-2 lh-1 pt-2 border-bottom-0 text-end ext-border-top ${onlyDisplay ? "ext-border-right" : ""}`}
                    colSpan={onlyDisplay ? 2 : 1}
                >
                    {t("passes.usedEntries")}:{" "}
                    <span className="bold">
                        {pass.up_entries - pass.up_entries_left}/{pass.up_entries}
                    </span>
                </td>
                {!onlyDisplay && (
                    <td className={`align-middle pe-0 pe-lg-2 py-2 ext-border-top ext-border-bottom text-center`} rowSpan={5}>
                        <DropdownButton id="dropdownMoreOptions" variant="outline-secondary" className="d-inline-block" size="sm" title={<FontAwesomeIcon icon={faEllipsisV} />}>
                            <Dropdown.Item as={Button} variant="link" onClick={() => setShowPurchaseDetailsModal(pass)}>
                                <FontAwesomeIcon icon={faEye} className="me-2" />
                                {t("passes.seePassPurchaseDetails")}
                            </Dropdown.Item>
                            {pass.up_entries - pass.up_entries_left > 0 && (
                                <Dropdown.Item as={Button} variant="link" onClick={() => setShowUserClassesToPassModal(pass)}>
                                    <FontAwesomeIcon icon={faEye} className="me-2" />
                                    {t("passes.showClassesAssignedToThisPass")}
                                </Dropdown.Item>
                            )}

                            {adminView && (
                                <>
                                    {pass.up_paid !== pass.up_price ? (
                                        <>
                                            {/* {pass.up_status_code !== "DELETED" && ( */}
                                            <Dropdown.Item as={Button} variant="link" onClick={() => setShowRegisterPaymentModal(pass)}>
                                                <FontAwesomeIcon icon={faCashRegister} className="me-2" />
                                                {t("payments.registerPayment")}
                                            </Dropdown.Item>
                                            {/*  )} */}
                                        </>
                                    ) : (
                                        <Dropdown.Item as={Button} variant="link" onClick={() => setShowCancelPaymentModal(pass)}>
                                            <FontAwesomeIcon icon={faBan} className="me-2" />
                                            {t("payments.cancelPayment")}
                                        </Dropdown.Item>
                                    )}
                                    {pass.up_status_code !== "DELETED" && (
                                        <>
                                            <Dropdown.Item as={Button} variant="link" onClick={() => sendReminder(pass)} disabled={pass.up_paid === pass.up_price}>
                                                <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
                                                {t("sendMailReminder")}
                                            </Dropdown.Item>
                                            <Dropdown.Item as={Button} variant="link" onClick={() => changeView({ nav: "passes", sub: "editUserPass", params: { pass: pass } })}>
                                                <FontAwesomeIcon icon={faPencil} className="me-2" />
                                                {t("passes.editPass")}
                                            </Dropdown.Item>
                                            <Dropdown.Item as={Button} variant="link" onClick={() => setShowDeletePassModal(pass)}>
                                                <FontAwesomeIcon icon={faTrash} className="me-2" />
                                                {t("passes.deletePass")}
                                            </Dropdown.Item>
                                        </>
                                    )}
                                </>
                            )}
                        </DropdownButton>
                    </td>
                )}
            </tr>
            <tr className={trStyle}>
                <td
                    className={`align-middle lh-1 border-bottom-0 pb-0 pb-lg-2 ${onlyDisplay ? "ext-border-left" : ""} ${onlyDisplay && !showUserName ? "ext-border-right" : ""}`}
                    colSpan={showUserName ? 1 : 2}
                >
                    {t("passes.activationDate")}:{" "}
                    {pass.up_activation_date ? (
                        <span className="bold">
                            {moment(pass.up_activation_date).format("DD.MM.YYYY")} - {moment(pass.up_end_date).format("DD.MM.YYYY")}
                        </span>
                    ) : (
                        <span className="opacity-4">{t("lack")}</span>
                    )}
                </td>
                {showUserName && (
                    <td className={`align-middle text-end lh-1 border-bottom-0 pb-0 pb-lg-2 ${onlyDisplay ? "ext-border-right" : ""}`} colSpan={showUserName ? 1 : 2}>
                        <FontAwesomeIcon icon={faUser} className="me-2" />
                        <Button className="p-0 text-body" variant="link" onClick={() => changeView({ nav: "users", sub: "userDetails", params: { userID: pass.user_id } })}>
                            {pass.user_name}
                        </Button>
                    </td>
                )}
            </tr>
            <tr className={trStyle}>
                <td className={`align-middle lh-1 border-bottom-0 pb-0 pb-lg-2  ${onlyDisplay ? "ext-border-left" : ""}`}>
                    {t("passes.activationTill")}: <span className="bold">{moment(pass.up_due_date).format("DD.MM.YYYY")}</span>
                </td>
                <td className={`align-middle lh-1 border-bottom-0 pb-0 pb-lg-2 text-end ${onlyDisplay ? "ext-border-right" : ""}`} colSpan={onlyDisplay ? 2 : 1}>
                    {t("payments.purchaseDate")}: <span className="bold d-inline-block">{moment(pass.up_purchase_date).format("YYYY-MM-DD")}</span>
                </td>
            </tr>
            <tr className={trStyle}>
                <td className={`align-middle lh-1 pb-2 border-bottom-0 ${onlyDisplay ? "ext-border-left" : ""}`}>
                    {pass.up_paid === 0 && pass.up_price > 0 ? (
                        <span className={pass.up_status_code !== "DELETED" ? "text-danger bold" : ""}>
                            <FontAwesomeIcon icon={faCircleXmark} className="me-2" />
                            {t("passes.notPaid")}
                        </span>
                    ) : pass.up_paid < pass.up_price ? (
                        <span className={pass.up_status_code !== "DELETED" ? "text-warning bold" : ""}>
                            <FontAwesomeIcon icon={faWarning} className="me-2" />
                            {t("passes.notFullyPaid")}
                        </span>
                    ) : pass.up_paid > pass.up_price ? (
                        <span className={pass.up_status_code !== "DELETED" ? "text-warning bold" : ""}>
                            <FontAwesomeIcon icon={faWarning} className="me-2" />
                            {t("passes.overPaid")}
                        </span>
                    ) : (
                        <span className={pass.up_status_code !== "DELETED" ? "text-success" : ""}>
                            <FontAwesomeIcon icon={faCircleCheck} className="me-2" />
                            {t("passes.paid")}
                        </span>
                    )}
                </td>
                <td className={`align-middle lh-1 border-bottom-0 pb-0 pb-lg-2 text-end ${onlyDisplay ? "ext-border-right" : ""}`} colSpan={onlyDisplay ? 2 : 1}>
                    <FontAwesomeIcon icon={faCoins} className="me-2" />
                    {pass.up_price.toFixed(2).toString().replace(".", ",")} {t("currency")}
                </td>
            </tr>
            <tr className={trStyle}>
                <td className={`align-middle lh-1 pb-2 ext-border-bottom ${onlyDisplay ? "ext-border-left" : ""}`}>
                    {t("passes.passStatus")}: {t(`passes.passStatuses.${pass.up_status_code}`)}
                </td>
                <td className={`align-middle lh-1 pb-2 ext-border-bottom text-end ${onlyDisplay ? "ext-border-right" : ""}`} colSpan={onlyDisplay ? 2 : 1}>
                    <>
                        {t("payments.declaredPaymentType")}: {t(pass.declared_payment_type_code ? `payments.paymentTypes.${pass.declared_payment_type_code}` : "noData")}
                    </>
                </td>
            </tr>

            {showPurchaseDetailsModal && <PurchaseDetailsModal up={showPurchaseDetailsModal} onClose={() => setShowPurchaseDetailsModal(false)} showPaymentsList />}
            {showUserClassesToPassModal && <UserClassesToPassModal onClose={() => setShowUserClassesToPassModal(false)} pass={showUserClassesToPassModal} />}
            {showRegisterPaymentModal && (
                <RegisterPaymentModal
                    pass={showRegisterPaymentModal}
                    onClose={() => {
                        setShowRegisterPaymentModal(false);
                        reloadData("passes");
                    }}
                />
            )}
            {showCancelPaymentModal && (
                <ConfirmModal
                    onClose={() => setShowCancelPaymentModal(false)}
                    show={true}
                    text={t("cancelPaymentModal.text", { passName: showCancelPaymentModal.pass_name, orderNumber: showCancelPaymentModal.order_number })}
                    proceedTxt={t("cancelPaymentModal.proceedTxt")}
                    cancelTxt={t("cancelPaymentModal.cancelTxt")}
                    onProceed={() => {
                        setShowCancelPaymentModal(false);
                        setAlerts([{ variant: "info", message: t("info.cancellingPayment") }]);
                        setTimeout(() => {
                            cancelPaymentForPass(showCancelPaymentModal);
                        }, 200);
                    }}
                    title={t("cancelPaymentModal.title")}
                />
            )}
            {showDeletePassModal && (
                <DeleteUserPassModal
                    onClose={() => setShowDeletePassModal(false)}
                    pass={showDeletePassModal}
                    onProceed={() => {
                        setShowDeletePassModal(false);
                        reload();
                    }}
                />
            )}
        </Fragment>
    );
};

export default UserPass;
